import { ReactElement } from "react";

import Navbar from "./navbar/Navbar";
import Viewport from "./viewport/viewport";

import "@justworkshr/milo-base-css/src/grid/grid.css";
import styles from "./app-layout.module.css";

export default function AppLayout(): ReactElement {
  return (
    <div className={`${styles.appLayout} milo--root`}>
      <section className={styles.navbar}>
        <Navbar />
      </section>

      <div className="milo--grid">
        <section className={styles.viewportGridItem}>
          <Viewport />
        </section>
      </div>
    </div>
  );
}
